import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { ReportPrintPage } from '@/features/reports/print-page';
import { bootSession } from '@/lib/auth/session';

const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .optional()
  .catch(undefined);

/** Outside the app shell on purpose: a clean page for the browser's print / Save as PDF. */
export const Route = createFileRoute('/print/projects/$projectId/reports/$reportKey')({
  validateSearch: z.object({ start: day, end: day }),
  beforeLoad: async ({ location }) => {
    const session = await bootSession();
    if (session.status === 'signed_out') {
      throw redirect({ to: '/signin', search: { return_to: location.href } });
    }
  },
  component: PrintRoute,
});

function PrintRoute() {
  const { projectId, reportKey } = Route.useParams();
  const range = Route.useSearch();
  return (
    <ReportPrintPage
      scope={{ kind: 'project', id: projectId }}
      reportKey={reportKey}
      range={range}
    />
  );
}
